import { connect } from 'react-redux'

import CheckoutCoupon from './CheckoutCoupon'
import { addCouponAsync, removeCouponAsync, updateCouponsAsync } from './couponActionCreators'

const mapCheckoutCouponStateToProps = (state) => {
    const isRequired = (state.entities.CartItems && state.entities.CartItems.some(item => item.RequiresPartnerId));
    return {
        Coupons: state.entities.Coupons,
        show: state.constants.allowCoupons && !!!state.ui.onPaymentScreen && isRequired,
        isExpanded: isRequired,
        isRequired: isRequired,
        toolTip: state.constants.partnerIdTooltip
    };
}

const mapCheckoutCouponDispatchToProps = (dispatch) => {
    return {
        onAddCoupon: (code) => (dispatch(addCouponAsync({ code }))),
        onRemoveCoupon: (code) => (dispatch(removeCouponAsync({ code }))),
        updateCoupons: () => dispatch(updateCouponsAsync())
    }
}

const CheckoutExpandedCouponContainer = connect(mapCheckoutCouponStateToProps, mapCheckoutCouponDispatchToProps)(CheckoutCoupon);

export default CheckoutExpandedCouponContainer